const headerElement = document.querySelector('.site-header');
const headerElementInner = headerElement.querySelector('.site-header__inner');
const root = document.documentElement;

function updateHeaderHeight() {
    const headerHeight = headerElement.offsetHeight;
    root.style.setProperty('--headerheight', `${headerHeight}px`);
    root.style.setProperty('--headerheight-padding', `${headerHeight}px`);
}

let isScrolled = false;

function applyScrollState() {
    const scrolled = window.scrollY > 100;

    if (scrolled !== isScrolled) {
        headerElement.classList.toggle('scrolled', scrolled);
        updateHeaderHeight();
        isScrolled = scrolled;
    }
}

// Run ASAP (before user scrolls)
applyScrollState();

// After DOM is ready, run again in case fonts/CSS shift layout
document.addEventListener('DOMContentLoaded', () => {
    requestAnimationFrame(() => {
        applyScrollState();
        updateHeaderHeight();  // final layout sync
    });
});

// Resize
window.addEventListener('resize', updateHeaderHeight);

// Scroll
window.addEventListener('scroll', applyScrollState);





/* const headerElement = document.querySelector('.site-header');
const headerElementInner = headerElement.querySelector('.site-header__inner');
const root = document.documentElement;

document.addEventListener('DOMContentLoaded', function() {
    function updateHeaderHeight() {
        const headerHeight = headerElement.offsetHeight;
        root.style.setProperty('--headerheight', `${headerHeight}px`);
        root.style.setProperty('--headerheight-padding', `${headerHeight}px`);
    }

    let isScrolled = false;

    function checkInitialScroll() {
        if (window.scrollY > 100) {
            headerElement.classList.add('scrolled');
            isScrolled = true;
        } else {
            headerElement.classList.remove('scrolled');
            isScrolled = false;
        }
        updateHeaderHeight();
    }

    // Initial call after layout is settled
    requestAnimationFrame(() => {
        checkInitialScroll();
    });

    // Update on resize
    window.addEventListener('resize', updateHeaderHeight);

    // Scroll listener — only update if scroll state changes
    window.addEventListener('scroll', function () {
        if (window.scrollY > 100 && !isScrolled) {
            headerElement.classList.add('scrolled');
            updateHeaderHeight();
            isScrolled = true;
        } else if (window.scrollY <= 100 && isScrolled) {
            headerElement.classList.remove('scrolled');
            updateHeaderHeight();
            isScrolled = false;
        }
    });
});
 */
